import React from 'react';
import {useAuth} from '../../contexts/AuthContext';
import {Route, Redirect} from 'react-router-dom';
import AuthLayout from '../../app/layout/AuthLayout';
import {useUserContext} from '../../contexts/UserContext';

const PrivateRoute = ({component: Component, pageTitle, authorisedRoles, ...rest}) => {
  const {authTokens: isAuthenticated} = useAuth();

  const roles = useUserContext();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          // check if route has role restriction
          if (authorisedRoles) {
            // check if route is restricted by role
            if (!roles.authorities.some(r => authorisedRoles.includes(r))) {
              // role not authorised so redirect to home page
              return <Redirect to={{pathname: '/'}}/>;
            } else {
              return <AuthLayout pageTitle={pageTitle}>
                <Component {...props} />
              </AuthLayout>;
            }
          } else {
            // authorised so return component
            return <AuthLayout pageTitle={pageTitle}>
              <Component {...props} />
            </AuthLayout>;
          }
        } else {
          // not logged in so redirect to login page with the return url
          return <Redirect to={{pathname: '/login', state: {referer: props.location}}}/>;
        }
      }}/>
  );
};

export default PrivateRoute;